import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {LocalPbxService} from '../local-pbx.service';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {NotificationService} from '../../notification/notification.service';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { HolidayGreetingsGridComponent } from './holiday-greetings-grid.component';

@Component({
    selector: 'app-pbx-holiday-greetings',
    templateUrl: './holiday-greetings.component.html',
    styleUrls: ['./holiday-greetings.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        HolidayGreetingsGridComponent,
    ],
})
export class HolidayGreetingsComponent extends BaseComponent implements OnInit, OnDestroy {

  filterOptions: FilterOptionModel[] = [];
  filterChangeEvent = new EventEmitter<void>();

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              public pbxService: LocalPbxService,
              private notificationService: NotificationService,
              private router: Router
  ) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.PbxHolidayGreetings_Edit, RolesEnum.PbxHolidayGreetings_Delete];
    this.deleteRoles = [RolesEnum.PbxHolidayGreetings_Delete];

    this.headerService.hideSearchInput();
  }

  ngOnInit() {
    super.ngOnInit();
    this.initFilterOptions();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.headerService.hideSearchInput();
    this.headerService.searchText.next('');
  }

  navigateToDetails() {
    this.router.navigate(['new'], {relativeTo: this.route}).then();
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
    ];
  }
}
